/**
 * Phase 37 — the draft's text mix input in one place: the ranking's proven
 * texts per drop and the kinds' own mixes, plus the Generation step's AI
 * texts per drop. Every mirror (scaling, cool-down, experiment) and the
 * Config tab read it through this. 21/10/2026 — the hit-again line comes
 * from Hit again's own Texts (a Verdicts value), never the Texts policy.
 * For Media Devoted | Created By Ciro Autiero
 */
import { type DropGenTextMix, type DropGenTextMixInput, type DropGenTextPolicy, withHitTexts, withoutHitTexts } from '@trafficpulse/shared';

interface MixDraft {
  creative: { amount: number; ranking: Pick<DropGenTextMixInput, 'provenPerDrop' | 'policy'> };
  hitAgain?: { texts: DropGenTextMix | null };
}

export const draftTextMix = (draft: MixDraft): DropGenTextMixInput => ({
  provenPerDrop: draft.creative.ranking.provenPerDrop,
  policy: withHitTexts(draft.creative.ranking.policy, draft.hitAgain?.texts ?? null),
  amount: draft.creative.amount,
});

/** A policy edited on the Config tab, split: the hit-again line goes to Hit again, the rest stays in Texts. */
export function splitHitTexts(policy: DropGenTextPolicy): { policy: DropGenTextPolicy; texts: DropGenTextMix | null } {
  return { policy: withoutHitTexts(policy), texts: policy.HIT_AGAIN ?? null };
}
